import { type ElementType } from "react";

import {
  AwsLogo,
  AzureLogo,
  GcpLogo,
  TencentCloudLogo,
  V2ProviderSelector,
  formatProviderFullName,
  type Provider,
} from "@stacklet/ui";

import { useConfig } from "app/contexts";
import { useStickyState } from "app/hooks";

const PROVIDER_LOGOS: Partial<Record<Provider, ElementType>> = {
  aws: AwsLogo,
  azure: AzureLogo,
  gcp: GcpLogo,
  tencentcloud: TencentCloudLogo,
};

interface Props {
  onChange: (provider: Provider) => void;
  /** Additional class name applied to the trigger element. */
  className?: string;
}

export function ProviderSelector({ onChange, className }: Props) {
  const [selectedProvider, setSelectedProvider] = useStickyState<Provider>(
    "aws",
    "provider",
  );

  const config = useConfig();
  const providers = (config?.cloud_providers ?? []) as Provider[];

  function handleChange(provider: Provider) {
    setSelectedProvider(provider);
    onChange(provider);
  }

  const v2Providers = providers.map((p) => ({
    logo: PROVIDER_LOGOS[p] ?? AwsLogo,
    key: p,
  }));

  return (
    <V2ProviderSelector
      className={className}
      formatProvider={formatProviderFullName}
      onChange={handleChange}
      providers={v2Providers}
      selected={selectedProvider}
      icons
    />
  );
}
